import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface DeleteDashboardAnalysisCriteria {
    analysisId: string;
    dashboardId: string;
}

class DeleteDashboardAnalysisCriteriaImpl implements DeleteDashboardAnalysisCriteria {
    constructor(readonly analysisId: string, readonly dashboardId: string) {}
}

export class DeleteDashboardAnalysisCriteriaBuilder {
    private analysisId: Option<string> = none;

    private dashboardId: Option<string> = none;

    static create = (): DeleteDashboardAnalysisCriteriaBuilder => new DeleteDashboardAnalysisCriteriaBuilder();

    withAnalysisId = (id: string): DeleteDashboardAnalysisCriteriaBuilder => {
        this.analysisId = some(id);
        return this;
    };

    withDashboardId = (id: string): DeleteDashboardAnalysisCriteriaBuilder => {
        this.dashboardId = some(id);
        return this;
    };

    build = (): DeleteDashboardAnalysisCriteria => {
        if (isNone(this.analysisId) || isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined id');
        }

        return new DeleteDashboardAnalysisCriteriaImpl(this.analysisId.value, this.dashboardId.value);
    };
}
